import { useEffect, useState } from 'react';
import { Wizard, Toast, Icon, Text } from '@lana-ui/common';
import { LoginLayout, TextLogin } from '@lana-ui/login';
import '../../Statics/Scss/Pages/datos-personales.scss';
import '@styles/Pages/realizarPago.scss';
import ProteccionDatosPersonales from '../../Components/Common/banner/ProteccionDatosPersonales';
import Paragraph from '../../Components/Common/common/src/paragraph/Paragraph';
import Progress from '../../Components/Common/common/src/progress/Progress';
import LoadingSpinner from '@helpers/LoadingSpinner';
import WondersoftFormIframe from './WondersoftFormIframe';
import { steps } from '../../Config/CheckoutSteps';
import useIniciarVenta from '../../Hooks/useIniciarVenta';
import GetParamURL from '../../Helpers/GetParamURL';
import { EventTrackAndLogData, PageViewTrackAndLogData } from '../../Config/TrackAndLogData';
import { readCookie } from '../../Helpers/Cookies';
import { createCustomDimension } from '../../Helpers/CustomDimension';
import GetLastClaimedArticleFromCallback from '../../Helpers/GetLastClaimedArticleFromCallback';
import { Button } from '@lana-ui/login';
import PhonesBanner from '../../Components/Common/banner/PhonesBanner';
import useObtenerMontoMinimoValidacionTarjeta from '../../Hooks/useObtenerMontoMinimoValidacionTarjeta';
import useProcesarPagoCobroMinimo from '../../Hooks/useProcesarPagoCobroMinimo';
import NotificationSevice from '../../Services/NotificationSevice';
import CheckoutStepper from '../../Models/CheckoutStepper';

const RealizarPago = ({ state, send }) => {
    const [dataIframe, error, isLoading, iniciarVenta] = useIniciarVenta();
    const EnvCheckout = process.env.REACT_APP_CHECKOUT;
    const planCampania = state.context?.planCampania;
    const datosPersonales = state.context?.datosPersonales;
    const { enabledDomicilio } = state.context;
    const [dataWondersoft, setDataWondersoft] = useState();
    const [dataPagoProcesado, errorPago, isLoadingPago, procesarPago] = useProcesarPagoCobroMinimo();
    const [montoMinimoValidacionTarjeta, errorMontoMinimo, isLoadingMontoMinimo] = useObtenerMontoMinimoValidacionTarjeta();
    const [showMonto, setShowMonto] = useState()
    const urlParams = GetParamURL();
    const canalDeVenta = state.context.canalDeVenta;
    const formaDeContacto = state.context.formaDeContacto;
    const [isLoadingWs, setIsLoadingWs] = useState(false);
    const [errorPagoWs, setErrorPagoWs] = useState(false);
    const [showToastErrorPagoWS, setShowToastErrorPagoWS] = useState(false);
    const [paid, setPaid] = useState();
    // const overridePayment = readCookie('adqSecretDebug');
    const { REACT_APP_ENV } = process.env;
    const mostrarMontoACobrar = dataIframe?.formularioWondersoft?.SeCobraMontoMinimoPorValidacion ? montoMinimoValidacionTarjeta : false;
    const crmId = dataIframe?.clienteResponse?.crmId ?? null;

    

    const blockBackBrowser = () => {
        window.addEventListener('popstate', () => {
            window.history.pushState(null, null, window.location.href);
            window.history.go(1);
        });
    };
    
    useEffect(() => {
        if(dataIframe){
            setShowToastErrorPagoWS(state.context?.showToastErrorWondersoft);
            NotificationSevice.saveStepInformation(state.context, CheckoutStepper.formularioPago);
        }
    }, [dataIframe])

    useEffect(() => {
        window.scrollTo(0, 180);
        //se inicia cuando se renderiza el componente por primera vez
        const dataWondersoft = {
            SitioOrigen: 'Paywall',
            planId: planCampania.id,
            campaniaId: state.context?.campaniaId,
            idCanalDeVenta: canalDeVenta,
            idFormaDeContacto: formaDeContacto,
            clienteModel: datosPersonales,
            domicilioModel: {
                domicilioExtranjero: !state.context.enabledDomicilio,
            }
        };
        setDataWondersoft(dataWondersoft);
        iniciarVenta(dataWondersoft, state.context?.correlationId, send);
        PageViewTrackAndLogData('formulario_pago', planCampania.descripcion);
    }, []);

    useEffect(() => {
        //se inicia cuando se hizo el pago de ws con error, y levanta el iframe de nuevo
        if(errorPagoWs){
            //Se cancela el log de guardado de datos de la venta.
            NotificationSevice.saveStepInformation(state.context, CheckoutStepper.ventaCancelada);                   
            setErrorPagoWs(false);
            volverDatosPersonales(true);
        }
        
    }, [errorPagoWs]);

    useEffect(() => {
        window.addEventListener('message', (event) => {
            if (event?.data === 'PaymentFormSubmit') {
                blockBackBrowser();
            }
        });
    }, []);

    const volverDatosPersonales = (showToastErrorWondersoft = false) => {
        //Updateo datos personales y  el crmId con la respuesta de iniciarVenta() para que quede el usuario precargado y asi saltear datos personales.
        send('CANCELAR', { datosPersonales: state.context.datosPersonales, crmId: crmId, showToastErrorWondersoft: showToastErrorWondersoft});
    };

    useEffect(() => {
        if (!!dataPagoProcesado) {
            createCustomDimension(); // actualiza el dataLayer de Google Analytics
            const callbackArticle = GetLastClaimedArticleFromCallback();
            const data = {
                name: planCampania.descripcion,
                price: planCampania.planes[0].precio, // es el precio que figura en el wall
                started: state.context.modo,
                article: 'N/A',
                sku: planCampania.id,
                category: urlParams.productCategory,
                brand: 'Web',
                quantity: planCampania.planes[0].cantidadDeCredenciales,
                EC_url_nota_PW: callbackArticle ? callbackArticle.url : 'N/A',
                canalVenta: canalDeVenta,
                formaContacto: formaDeContacto,
            };
            EventTrackAndLogData('pago-ok', data);
        }
    }, [dataPagoProcesado]);

    const handleCloseToast = () => {
        setShowMonto(false);
    };

    return (
        <>
            {showToastErrorPagoWS && (
                <Toast status={'warning'} title="¡Ups!" type={'toast'} value={showToastErrorPagoWS} closeAuto={true} close className="--roboto" changeValue={() => setShowToastErrorPagoWS(false)}>
                    No pudimos procesar tu pago. Por favor, verificá los datos ingresados o intentá con otro medio de pago.
                </Toast>
            )}

            <LoadingSpinner isLoading={isLoading || isLoadingWs || isLoadingMontoMinimo}>
                <div className="realizar-pago">
                    {error ? (
                        <Toast status="warning" title="¡Uppps!" type="alert">
                            <Paragraph className="--roboto">
                                Ha ocurrido un inconveniente. Por favor volvé a intentar
                            </Paragraph>
                        </Toast>
                    ) : (
                        <>
                            {mostrarMontoACobrar && (
                                <Toast status={'info'} title="Información" type={'toast'} closeAuto={true} close={handleCloseToast} changeValue={handleCloseToast}>
                                    <Paragraph className="--roboto">
                                        Para confirmar la compra del plan, <span style={{ fontWeight: 'bold' }}>realizaremos un pequeño cargo de ${montoMinimoValidacionTarjeta}</span> para validar tu{' '}
                                        tarjeta, que <span style={{ fontWeight: 'bold' }}>luego te devolveremos</span>.
                                    </Paragraph>
                                </Toast>
                            )}
                            <div className="progress-steps">
                                <Wizard activeStep={3} steps={steps} />
                                <div className="progress-steps__container">
                                    <Progress currentNumber={steps.step_3.number} amountTotalNumbers={Object.values(steps).length} />
                                    <div className="progress-steps__container__data">
                                        <Text size="4xs" className="--arial --font-bold">
                                            {steps.step_3.text}
                                        </Text>
                                    </div>
                                </div>
                            </div>
                            <TextLogin title="¿Cómo querés pagar?">
                                <Text as="p" size="4xs">
                                    Ingresá los datos de tu tarjeta de crédito
                                </Text>
                            </TextLogin>
                            <div className="cards">
                                <Icon size="l" icon="amexCard" />
                                <Icon size="l" icon="visaCard" />
                                <Icon size="l" icon="masterCard" />
                                <Icon size="l" icon="cabalCard" />
                                <Icon size="l" icon="dinnerClubCard" />
                                <Icon size="l" icon="naranjaCard" />
                            </div>
                            {dataWondersoft && (
                                <WondersoftFormIframe
                                    ActionUrl={dataIframe?.formularioWondersoft?.UrlWondersoftPost}
                                    Hash={dataIframe?.formularioWondersoft?.Hash}
                                    Password={dataIframe?.formularioWondersoft?.Password}
                                    RedirectUrl={`${EnvCheckout}procesar-cobro`}
                                    Token={dataIframe?.formularioWondersoft?.Token}
                                    TipoTransaccion={dataIframe?.formularioWondersoft?.TipoTransaccion}
                                    correlationId={dataIframe?.CorrelationId}
                                    dataVenta={dataWondersoft}
                                    procesarPago={procesarPago}
                                    state={state}
                                    send={send}
                                    setIsLoadingWs={setIsLoadingWs}
                                    errorPagoWs={errorPagoWs}
                                    setErrorPagoWs={setErrorPagoWs}
                                    setPaid={setPaid}
                                />
                            )}
                        </>
                    )}

                    {/* button para saltear pagina
                    {REACT_APP_ENV !== 'PROD' && overridePayment === 'saltearPago' && (
                        <button
                            onClick={() => {
                                send('CONTINUARARGENTINO', {
                                    dataVenta: {
                                        ventaResponse: {
                                            CorrelationId: '038c5b7b-df30-4039-8d5e-991c23aeb362',
                                            AddressId: 'aR1001433782',
                                        },
                                    },
                                });
                            }}
                        >
                            CONTINUAR
                        </button>
                    )} */}

                    <PhonesBanner />
                    <ProteccionDatosPersonales />
                </div>
            </LoadingSpinner>
        </>
    );
};

export default RealizarPago;
